import { render, staticRenderFns } from "./Gravatar.vue?vue&type=template&id=0409309b&"
import script from "./Gravatar.vue?vue&type=script&lang=ts&"
export * from "./Gravatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports